import React from 'react';
import PropTypes from 'prop-types';
import {Box, Flex, Image, Text} from 'rebass'
import check from "../../resources/img/icons/Checkbox@1x-black.png";
import {Divider} from "reakit";


const SelectInput = props => {
	const {value, type, label, selected, onChange} = props;

	const handleSelect = () => {
		onChange(value, type)
	}
	return (
		<Box width={1} onClick={handleSelect} pt={'12px'}>
			<Flex>
				<Box>
					<Text color={'black'} ml={3}>{label}</Text>
				</Box>
				<Box ml={'auto'}/>
				<Box pr={2} pt={'5px'}>
					{selected && <Image src={check}/>}
				</Box>
			</Flex>
			<Box width={1}>
				<Divider marginBottom={0}/>
			</Box>
		</Box>
	);
};

SelectInput.propTypes = {
	selected: PropTypes.bool,
	onChange: PropTypes.func,
	value: PropTypes.string,
	label: PropTypes.string,
	type: PropTypes.string
};

SelectInput.defaultProps = {
	selected: false,
	label: "",
	type: 'type',
	value: '123456'
}

export default SelectInput;
